import Axios from 'axios';
import Cookies from 'js-cookie';
import qs from 'qs';

let dns = null;
let proxyRequired = window.cors;
let isIptveditor = null;

setDns(window.dns);

export async function get(url, timeout = 1) {
  return Axios.get(url).catch((err) => err);
}

export async function post(url, params = {}, local, useProxy) {
  if (!dns) return null;

  let uri = url;

  const needsProxy =
    proxyRequired ||
    useProxy ||
    (window.location.protocol === 'https:' && dns.startsWith('http://'));

  if (needsProxy && isIptveditor === true) {
    return Axios.post(
      '/proxy.php?url=' + encodeURIComponent(dns) + '&method=POST',
      qs.stringify(params),
      { timeout: 25000 }
    ).catch((err) => {
      if (!err.response) return post(url, params, local, true);
      return err;
    });
  } else if (needsProxy && isIptveditor === false) {
    const queryParams = [];
    for (const key in params) {
      queryParams.push(key + '=' + encodeURIComponent(params[key]));
    }
    uri += '?' + queryParams.join('&');
    const targetUrl = dns + uri;
    // Fazer GET para proxy.php com URL completa (query params já estão na URL)
    return Axios.get('/proxy.php?url=' + encodeURIComponent(targetUrl), {
      timeout: 25000,
    }).catch((err) => {
      if (!err.response) return post(url, params, local, true);
      return err;
    });
  } else if (isIptveditor === false) {
    // Para Xtream sem proxy, construir query string na URL e fazer GET
    uri += '?';
    for (const key in params) {
      uri += key + '=' + encodeURIComponent(params[key]) + '&';
    }
    return Axios.get(dns + uri, { timeout: 25000 }).catch((err) => {
      if (!err.response) return post(url, params, local, true);
      return err;
    });
  } else {
    return Axios.post(dns + uri, qs.stringify(params), {
      timeout: 25000,
    }).catch((err) => {
      if (!err.response) return post(url, params, local, true);
      return err;
    });
  }
}

export function setDns(data) {
  if (!data) return;

  isIptveditor = !!data.match(
    /iptveditor\.com|xtream-ie|opop\.pro|localhost|192\.168\.178\.71\:3100/
  );

  if (window.isDebug === 1) data = window.dns;
  else if (isIptveditor === true && window.isDebug !== 1) {
    const iptveditorApi =
      typeof window !== 'undefined' && window.REACT_APP_IPTVEDITOR_API
        ? window.REACT_APP_IPTVEDITOR_API
        : process.env.REACT_APP_IPTVEDITOR_API || '';
    if (iptveditorApi) {
      data = `${iptveditorApi}webplayer`;
    }
  } else {
    if (data[data.length - 1] !== '/') data += '/';
  }

  dns = data;
  Cookies.set('dns', data, { expires: 365 });
}

export function getDns() {
  return dns;
}

export function getIsIptveditor() {
  return isIptveditor;
}
